import React from 'react';
import PropTypes from 'prop-types';
import Row from 'reactstrap/lib/Row';
import Col from 'reactstrap/lib/Col';
import classnames from 'classnames';
import { VehicleEntities } from 'client/data/models/vehicle-v2';
import { VisitorEntities } from 'client/data/models/visitor';
import { isUsed } from 'site-modules/shared/utils/publication-states';
import { FeaturesSpecsParams } from 'site-modules/shared/utils/features-specs/params';
import { FeaturesSpecsOverview } from 'site-modules/features-specs/components/features-specs-overview/features-specs-overview';
import { FeaturesSpecsDetails } from 'site-modules/features-specs/components/features-specs-details/features-specs-details';
import { NewPricing } from 'site-modules/features-specs/components/new-pricing/new-pricing';

import './features-specs-table.scss';

/**
 * todo refactor FeaturesSpecsOverview, FeaturesSpecsDetails into stand-alone components and loose FeaturesSpecsTable
 */
export function FeaturesSpecsTable({
  className = null,
  vehicle,
  params,
  styleId = null,
  trimName = null,
  visitorLocation = null,
  pageName = null,
  isMobile = false,
}) {
  return (
    <Row className={classnames('features-specs-table', className)}>
      <Col xs={12} md={8}>
        {/* above fold ... */}
        <FeaturesSpecsOverview params={params} styleId={styleId} />
        {/* below fold ... */}
        <FeaturesSpecsDetails
          vehicle={vehicle}
          params={params}
          styleId={styleId}
          isMobile={isMobile}
          visitorLocation={visitorLocation}
          trimName={trimName}
          pageName={pageName}
        />
      </Col>
      {!isUsed(vehicle.pubStates) && !isMobile && (
        <Col xs={12} md={4} className="pos-r">
          <NewPricing vehicle={vehicle} styleId={styleId} trimName={trimName} />
        </Col>
      )}
    </Row>
  );
}

FeaturesSpecsTable.propTypes = {
  vehicle: VehicleEntities.MakeModelSubmodelYear.isRequired,
  params: FeaturesSpecsParams.isRequired,
  styleId: PropTypes.number,
  className: PropTypes.string,
  trimName: PropTypes.string,
  visitorLocation: VisitorEntities.Location,
  pageName: PropTypes.string,
  isMobile: PropTypes.bool,
};
